var React = require('react');
var Col = require('react-bootstrap').Col;
var Row = require('react-bootstrap').Row;

var BillingActions = require('../../actions/BillingActions');
var Currency = require('../../util/Currency');
var InvoiceActions = require('../../actions/InvoiceActions');
var InvoiceStore = require('../../stores/Invoice/InvoiceStore');
var Invocation = require('../../api/Invocation');
var GroupedPayment = require('../Payment/GroupedPayment');
var BillingGroupStore = require('../../stores/BillingGroupStore');
var PaymentStore = require('../../stores/PaymentStore');
var PaymentTokenStore = require('../../stores/PaymentTokenStore');
var ServiceActions = require('../../actions/ServiceActions');

function getState() {
    return {
        amount: PaymentStore.amount,
        saveBg: BillingGroupStore.get().length === 1,
        card: PaymentStore.card,
        cardErrors: PaymentStore.cardErrors,
        invoices: InvoiceStore.getUnpaid() || [],
        invoicesLoading: InvoiceStore.loading(),
        lastPayment: PaymentStore.getPayment(),
        selectedInvoices: PaymentStore.selectedInvoices,
        tokenErrors: PaymentStore.tokenErrors,
        token: PaymentStore.token,
        tokens: PaymentTokenStore.get() || [],
        tokensLoading: PaymentTokenStore.loading(),
        working: PaymentStore.loading()
    };
}

var Payment = React.createClass({
    componentDidMount: function() {
        InvoiceStore.addChangeListener(this.update);
        PaymentStore.addChangeListener(this.update);
        PaymentTokenStore.addChangeListener(this.update);
    },
    componentWillMount: function () {
        ServiceActions.getServices(); // Here because we need tokens, and right now thats where they come from..
        InvoiceActions.getInvoices(null, {unpaid: true});
    },
    componentWillUnmount: function () {
        InvoiceStore.removeChangeListener(this.update);
        PaymentStore.removeChangeListener(this.update);
        PaymentTokenStore.removeChangeListener(this.update);
    },
    getInitialState: function () {
        return getState();
    },
    handlePayment: function (e) {
        e && e.preventDefault();

        BillingActions.doPayment();
    },
    render: function () {
        return <section id="payment" className="powerwidget">
            <header><h2>Make a Payment</h2></header>
            <div className="inner-spacer">
                {this.renderLastPayment()}
                <div className="callout callout-info">
                    <p>Do you have any domains registered with Infinite Networks? Your credit card may also be saved in our <a href="https://infinite.partnerconsole.net/" target="_blank">domains portal</a>. Make sure to update your credit card there when necessary.</p>
                </div>
                <GroupedPayment
                    amount={this.state.amount}
                    card={this.state.card}
                    cardErrors={this.state.cardErrors}
                    disabled={!!this.state.lastPayment}
                    onCardUpdate={BillingActions.updateCard}
                    onInvoiceSelection={BillingActions.selectInvoice}
                    onPay={this.handlePayment}
                    onTokenSelection={BillingActions.selectToken}
                    invoices={this.state.invoices}
                    invoicesLoading={this.state.invoicesLoading}
                    saveBg={this.state.saveBg}
                    selectedInvoices={this.state.selectedInvoices}
                    token={this.state.token}
                    tokens={this.state.tokens}
                    tokensLoading={this.state.tokensLoading}
                    working={this.state.working} />
            </div>
        </section>;
    },
    renderLastPayment: function () {
        if (!this.state.lastPayment) {
            return;
        }

        return <div className="callout callout-info">
            <p>Thank you for your payment! The reference number for your payment
            of <strong>{Currency.format(this.state.lastPayment.amount)}</strong> is&nbsp;
            <strong>{this.state.lastPayment.reference}</strong>.</p>

            <p><a className="btn btn-info" onClick={BillingActions.newPayment}>Start new payment</a></p>
        </div>
    },
    update: function() {
        this.setState(getState());
    }
})
module.exports = Payment;



// WEBPACK FOOTER //
// ./app/components/Accounting/Payment.js